import { ChangeDetectionStrategy, Component, Inject, signal, Signal, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactsMap, PhoneNumberOption, PhoneNumberOptions, PhoneNumberOptionType, PhoneNumberOptionTypeMap, ViaPhoneNumbers } from '../select-phone-number';
import parsePhoneNumber from 'libphonenumber-js';
import { LoggerService } from '@sko/ng-logging';
import { ApiService } from '../api.service';

export type SelectPhoneNumberDialogData = {
  from?: string;
  type: PhoneNumberOptionType;
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-select-phone-number-dialog',
    templateUrl: './select-phone-number-dialog.component.html',
    styleUrl: './select-phone-number-dialog.component.sass',
    standalone: false
})
export class SelectPhoneNumberDialogComponent {

  readonly from?: string;

  label: string;

  readonly loading: Signal<boolean>;

  private readonly loadingSignal: WritableSignal<boolean>;

  readonly options: Signal<PhoneNumberOptions>;

  private readonly optionsSignal: WritableSignal<PhoneNumberOptions>;

  readonly type: PhoneNumberOptionType;

  constructor(
    private api: ApiService,
    @Inject(MAT_DIALOG_DATA) data: SelectPhoneNumberDialogData,
    private dialog: MatDialogRef<SelectPhoneNumberDialogComponent, PhoneNumberOption>,
    private logger: LoggerService,
  ) {

    this.from = data.from;

    this.type = data.type;

    this.loadingSignal = signal<boolean>(true);

    this.loading = this.loadingSignal.asReadonly();

    this.optionsSignal = signal<PhoneNumberOptions>([]);

    this.options = this.optionsSignal.asReadonly();

    logger.info({ from: this.from, type: this.type, ContactsMap }, 'Dialog');

    Promise.resolve().then((): any => {

      switch (this.type) {

        case PhoneNumberOptionTypeMap.CONTACTS:
  
          this.optionsSignal.set((this.from) ? ContactsMap[this.from] : []);
  
          this.label = 'Contacts';
  
          break;
  
        case PhoneNumberOptionTypeMap.TWILIO:
  
          this.label = 'Twilio';
  
          return this.api.listPhoneNumbers()
          .then((result) => {

            this.optionsSignal.set(result.map((phoneNumber) => {

              return {
                label: phoneNumber.friendlyName,
                phone_number: phoneNumber.phoneNumber,
              };

            }));

          });
  
        case PhoneNumberOptionTypeMap.VIA:
  
          this.optionsSignal.set(ViaPhoneNumbers);
  
          this.label = 'Via';
  
          break;
  
      }
  
    })
    .then(() => {

      this.loadingSignal.set(false);

    });

    this.logger.info({ options: this.options, label: this.label }, 'Dialog');

  }

  closeDialog() {

    this.dialog.close();

  }

  formatPhoneNumber(phone_number: string) {

    const pn = parsePhoneNumber(phone_number);

    return pn?.formatNational();

  }

  onChange(option: PhoneNumberOption) {

    this.dialog.close(option);

  }

}
